<template>
    <v-card  height="100%">
        <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>
        <DlgNotificationSettingAdd ref="dlgCommon" :visible="visible" @close="dlgClose"></DlgNotificationSettingAdd>
        <div class="pa-3">
            <v-toolbar>
            <v-toolbar-title>Notification Setting List</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-breadcrumbs :items="items"></v-breadcrumbs>
            </v-toolbar>
        </div>
        <div class="pa-3">
        <v-card>
        <v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark class="primary mr-2" @click="refreshDataTable"><v-icon>mdi-refresh</v-icon></v-btn>         
        <v-btn icon dark class="mb-2 success" @click="addRecord">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>

        <v-text-field
            v-model="tblSearch"
            append-icon="mdi-magnify"
            label="Search data below"
            hide-details
            outlined
        ></v-text-field>
        </v-card-text>

        <v-data-table
        v-model="selected"  
        ref="vuetable"
        item-key="created_date"
        :headers="tblHeaders"
        :items="tblBody"
        :search="tblSearch"
        :loading = "loadingFlag"
        loading-text="Loading... Please wait"    
        @click:row="openDetail"
        ></v-data-table>
        </v-card>
        </div>

    </v-card>

</template>
<script>
//import axios from 'axios';
import DlgMessage from '@/components/DlgMessage'
import ApNotificationService from "@/services/ApNotificationService"
import DlgNotificationSettingAdd from "@/components/DlgNotificationSettingAdd";
export default {
    components:{DlgMessage,DlgNotificationSettingAdd},
    data() {
        return{
            //breadcrumb
            items: [
              {text:'Notification',disabled: false,href:'/notification',},
              {text:'Setting',disabled: false,href:'/notification/settings',},
              {text:'List',disabled: false,href:'#',},
              ],
            selected: [],
            tblHeaders:[
                { text:"Code", value:"ns_code" },
                { text:"Name", value:"ns_name" },
                { text:"Topic", value:"topic" },
                { text:"Status", value:"status" },
            ],
            tblBody:[],
            tblSearch:'',
            loadingFlag : false,
            errorFlag : false,
            visible:false,
            form:{
                merchant_id:0,
                login_id:'',
            },

        }
    },
    async created() {
      this.refreshDataTable();
    },
    mounted(){
        this.initFCM();
    },
    methods:{
            async refreshDataTable(){
                this.loadingFlag = true
                try{
                    ApNotificationService.list_notification_setting(this.form).then((res) => {
                        //console.log(res);
                        this.tblBody = res.data.data;
                        this.loadingFlag = false;
                        this.errorFlag = false;
                    }).catch((e)=>{
                        //console.log(e.response);
                        this.$refs.dlgMsg.showDlgBox(true,'error','Notification Setting',e.response.data.error_message);
                        this.loadingFlag = false
                        this.errorFlag = true;
                    })
                    ;
                } catch(e) {
                    this.loadingFlag = false
                    this.$refs.dlgMsg.showDlgBox(true,'error','Notification Setting','Unknown Error');
                  
                }           
            },
			openDetail(obj){
				console.log(obj.notification_setting_id)
				this.$router.push({ name: 'notification-setting-details', 
					params: { 
						notification_setting_id: obj.notification_setting_id,
						enc_ns_name: btoa(obj.ns_name),
					} 
				})

			},

            addRecord(){
                this.visible = true;
            },
            dlgClose(){
                this.visible = false;
                if(!this.errorFlag)
                    this.refreshDataTable();
            },
    }

}
</script>